export default "__VITE_ASSET__Bn0fn955__"